import { useLazyQuery } from '@apollo/client';
import { BlogWithoutId, BlogsResponse } from 'apolloClient/types/Blog';
import { GET_BLOGS_BY_SLUG_LIST } from 'apolloClient/queries/blogs';
import { useEffect, useState } from 'react';
import { StrapiResponseData } from 'apolloClient/types';

const usePopularBlogsCommon = (fetchUrl?: string) => {
  const [slugs, setSlugs] = useState<Array<string>>([]);
  const [blogs, setBlogs] = useState<Array<StrapiResponseData<BlogWithoutId>>>(
    []
  );

  const [fetchBlogs] = useLazyQuery<
    Record<'blogs', BlogsResponse>,
    Record<'slugList', Array<string>>
  >(GET_BLOGS_BY_SLUG_LIST, {
    onCompleted: (response) => {
      const modifiedResponse = (response.blogs.data || [])
        .slice(0, 5)
        .sort(
          (a, b) =>
            slugs.indexOf(a.attributes.slug) - slugs.indexOf(b.attributes.slug)
        );
      setBlogs(modifiedResponse);
    },
  });

  useEffect(() => {
    if (fetchUrl) {
      fetch(fetchUrl).then(async (res) => {
        const blogSlugs: Array<string> = await res.json();

        setSlugs(blogSlugs);

        return res;
      });
    }
  }, [fetchUrl]);

  useEffect(() => {
    fetchBlogs({ variables: { slugList: slugs } });
  }, [fetchBlogs, slugs]);

  return {
    popularBlogs: blogs,
  };
};

export const usePopularBlogs = () => {
  const endpointUrl = '/api/getGooglePopularBlogs';

  return usePopularBlogsCommon(endpointUrl);
};

export const usePopularBlogsByTag = (tagLabel?: string | string[]) => {
  const endpointUrl = '/api/getGooglePopularBlogs';

  return usePopularBlogsCommon(
    tagLabel ? `${endpointUrl}?tagName=${tagLabel}` : undefined
  );
};
